<template>
<div>
  <div v-if="$auth.isAuthenticated">
    <li class="nav-item dropdown">
      <a
        class="nav-link pr-0"
        href="#"
        role="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <div class="media align-items-center">
          <span class="avatar avatar-sm rounded-circle">
            <img alt="User Image" :src="userImageOrDefault" />
          </span>
          <div class="media-body d-none d-lg-block">
            <span class="mb-0 ml-2 text-sm font-weight-bold">{{userName}}</span>
          </div>
        </div>
      </a>
      <div class="dropdown-menu dropdown-menu-right">
        <div class="dropdown-header noti-title">
          <h6 class="text-overflow m-0">Welcome!</h6>
        </div>
        <div v-if="!userNeedsOnboard">

          <router-link to="/my/profile" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>My Settings</span>
          </router-link>
          <router-link :to="workspaceLink" class="dropdown-item">
            <i class="img-icon img-icon-joint-account"></i>
            <span>Workspace Settings</span>
          </router-link>

          <router-link to="/billing" class="dropdown-item">
            <i class="img-icon img-icon-cheque"></i>
            <span>Billing</span>
          </router-link>

          <a @click="downloadHQ" class="dropdown-item" download>
            <i class="img-icon img-icon-system-update"></i>
            <span>Download macOS App</span>
          </a>

<!--          <router-link to="/profile" class="dropdown-item">-->
<!--            <i class="ni ni-single-02"></i>-->
<!--            <span>My Profile</span>-->
<!--          </router-link>-->
<!--          <router-link to="/invites" class="dropdown-item">-->
<!--            <i class="ni ni-send"></i>-->
<!--            <span>My Invites</span>-->
<!--          </router-link>-->
<!--          &lt;!&ndash; Settings is app specific, disable this link by setting the settings: false prop &ndash;&gt;-->
<!--          <router-link to="/management" class="dropdown-item">-->
<!--            <i class="img-icon img-icon-joint-account"></i>-->
<!--            <span>Account Users</span>-->
<!--          </router-link>-->

<!--          <router-link to="/billing" class="dropdown-item">-->
<!--            <i class="img-icon img-icon-cheque"></i>-->
<!--            <span>Billing</span>-->
<!--          </router-link>-->
<!--          <router-link to="/subscription" class="dropdown-item">-->
<!--            <i class="img-icon img-icon-cheque"></i>-->
<!--            <span>Subscription</span>-->
<!--          </router-link>-->

<!--          <router-link to="/settings" class="dropdown-item">-->
<!--            <i class="img-icon img-icon-cheque"></i>-->
<!--            <span>Settings</span>-->
<!--          </router-link>-->

          <div class="dropdown-divider"></div>
        </div>

        <!-- <router-link to="https://www.imagineproducts.com/help/contact-us" class="dropdown-item" target="_blank">
          <i class="ni ni-settings-gear-65"></i>
          <span>Support</span>
        </router-link> -->
        <a @click="contactUs" class="dropdown-item" target="_blank">
          <i class="ni ni-support-16"></i>
          <span>Support</span>
        </a>
        <a @click="logOutClicked" class="dropdown-item">
          <i class="ni ni-user-run"></i>
          <span>Logout</span>
        </a>
      </div>
    </li>
  </div>

</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getEnv, VUE_IS_BETA, VUE_IS_TEST } from '#/utils/env';
// import { getEnv, VUE_APP_SUPPORT_PAGE } from '#/utils/env';

export default {
  data() {
    // TODO: fix these flags and env vars
    const testPrefix = '';
    const betaSuffix = '?beta=true'; // TODO: FIX - hard coded to beta download
    // const testPrefix = getEnv(VUE_IS_TEST) === 'true' ? 'test.' : ''; // to be used as url prefix to hit testing cluster
    // const betaSuffix = getEnv(VUE_IS_BETA) === 'true' ? '?beta=true' : ''; // to be used as url suffix to append query param
    const hqDownload = `https://${testPrefix}activation.imagineproducts.com/download/latest/902/${betaSuffix}`;
    console.info('HQ Download Link: ', getEnv(VUE_IS_TEST), getEnv(VUE_IS_BETA), hqDownload);
    return {
      hqDownload,
    };
  },
  props: {
  },
  methods: {
    logOutClicked() {
      console.log('Logging out');
      this.$auth.logout();
    },
    contactUs() {
      window.location = 'https://www.imagineproducts.com/help/contact-us';
    },
    downloadHQ() {
      console.info('downloading Imagine HQ');
      window.open(this.hqDownload, '_blank');
    },
  },
  computed: {
    ...mapGetters('user', [
      'userPhoto',
      'userNeedsOnboard',
    ]),
    // supportPage() {
    //   return getEnv(VUE_APP_SUPPORT_PAGE);
    // },
    workspaceLink() {
      const currentWorkspace = this.$store.getters.activeWorkspaceId;
      if (currentWorkspace) {
        return `/workspace/${currentWorkspace}`;
      }
      // if there isn't a current workspace - use the last one
      const lastWorkspace = this.$store.getters.lastActiveWorkspaceId;
      if (lastWorkspace) {
        return `/workspace/${currentWorkspace}`;
      }
      // TODO: what do we do here
      console.error('error computing workspace link');
      return undefined;
    },
    userImageOrDefault() {
      return this.userPhoto ? this.userPhoto : '/img/icons/account/account-circle.svg';
    },
    userName() {
      // See if we have an image from firebase
      const { user } = this.$auth; // TODO auth change
      if (user.displayName) {
        return user.displayName;
      }
      if (user.email) {
        return user.email;
      }
      return 'Unknown';
    },
  },
};
</script>
